import { IArea, IShiftHistory, IZone } from "../../../../../types";

export interface IUserBase {
  userID: number;
  userName: string;
  email: string;
}

export interface IEntity {
  id: number;
  name: string;
}

export interface IField9Type {
  begin: string;
  middle: string;
}

export interface IField10Type {
  f1Crane: string;
  ghCrane: string;
  f2Crane: string;
  chsCrane: string;
}

export interface IField12Type {
  nose: string | number;
  tail: string | number;
  lost?: number;
}

export interface IField13Type {
  nose: string | number;
  lost?: number;
}

export interface IField14Type {
  product?: ISystemEnumItem;
  nose: string | number;
  tail: string | number;
  lost?: number;
}

export interface IShiftReportContent {
  field1: string;
  field2: string;
  field3: string;
  field4: string;
  field5: string;
  field6: string;
  field7: string;
  field8: string;
  field9: IField9Type;
  field10: IField10Type;
  field11?: string;
  billetsRolled?: number;
  field12?: IField12Type;
  field13?: IField13Type;
  field14?: IField14Type | IField14Type[];
  maintenanceSAP?: IMaintenanceSAP;
  rmCheckList?: IRMCheckList;
}

export interface ISAPItem {
  failureReported: string;
  notificationNr: string;
}

export interface IMaintenanceSAP {
  items: ISAPItem[];
}

export enum CheckValueType {
  NONE = "NONE",
  YES = "YES",
  NO = "NO",
  NA = "NA"
}

export interface IRMCheckList {
  guBurnInIntermediateMillCheckList_8_15_2023: CheckValueType;
  checkListAfterCobbles: CheckValueType;
  checkListPassChangeNtm_rev_2: CheckValueType;
  checkListWithBarInTheMill_2024: CheckValueType;
  intermediateMillChecklist_2024: CheckValueType;
  mainPulpitCheckSheet_rev2: CheckValueType;
  startupChecks: CheckValueType;
}

export interface IShiftReportRM {
  shiftReportID: number;
  area: IArea;
  zone: IZone | null;
  user: IUserBase | null;
  factoryDay: string;
  shift: IShiftHistory;
  content: IShiftReportContent | null;
  isSubmitted: boolean;
}

export interface IShiftReportEdited {
  shiftReportID: number;
  areaID: number;
  zoneID: number | null;
  userID: number | null;
  shiftHistoryID: number;
  content: IShiftReportContent;
}

export interface IPanelProps<T> {
  onChange: (property: keyof IShiftReportContent, value: any) => void;
  property: keyof IShiftReportContent;
  value: T;
}

export interface ISystemEnumItem {
  name: string;
  value: any;
}

export interface ISystemEnum {
  name: string;
  values: ISystemEnumItem[];
}

